export default "__VITE_ASSET__b6446bd6__"